"use strict";

exports.__esModule = true;
exports.DeviceTableElement = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _polished = require("polished");
var _reactRouterDom = require("react-router-dom");
var _reactWindow = require("react-window");
var _DeviceContext = require("../../Device/DeviceContext");
var _DeviceListContext = require("../../Device/DeviceListContext");
var _Core = require("../../Core");
var _ConfigurableLayout = require("../../ConfigurableLayout");
var _UserActions = require("../../UserActions");
var _Device = require("../../Device");
var _common = require("../common");
var _TileContext = require("../common/TileContext");
var _stateEdge = require("../common/stateEdge");
var _Theme = require("../../Theme");
var _MetricValueBatchProvider = require("../MetricValue/MetricValueBatchProvider");
var _excluded = ["backgroundColor"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
// The table from the next-gen design: one white shadow card, a small-caps
// header row, rows separated by soft dividers, and every value drawn flat in
// its cell rather than as a tile of its own.
var HEADER_HEIGHT = 40;
var CELL_PAD_X = 12;
var CELL_PAD_Y = 8;

// Which kind of flat line a column's widget becomes. Anything else (a chart,
// a table) renders as it normally would.
var TITLE_TYPES = ["DeviceProperty"];
var STATE_TYPES = ["TimelineValue", "AdvancedTimelineValue"];
var STAT_TYPES = ["MetricValue", "MetricValueAggregate", "PerformanceParameterValue", "Clock"];
function roleOf(type) {
  if (TITLE_TYPES.includes(type)) return "title";
  if (STATE_TYPES.includes(type)) return "state";
  if (STAT_TYPES.includes(type)) return "stat";
  return undefined;
}
var safeMix = function safeMix(amount, color, base) {
  try {
    return (0, _polished.mix)(amount, color, base);
  } catch (e) {
    return base;
  }
};
var TableCard = _styledComponents["default"].div.withConfig({
  displayName: "DeviceTableElementmodern__TableCard",
  componentId: "sc-16zfe3t-0"
})(["position:relative;box-sizing:border-box;overflow:hidden;background:#ffffff;border-radius:12px;box-shadow:", ";"], (0, _Theme.val)("CardShadow"));
var HeaderRow = _styledComponents["default"].div.withConfig({
  displayName: "DeviceTableElementmodern__HeaderRow",
  componentId: "sc-16zfe3t-1"
})(["display:flex;align-items:center;background:#f8fafb;border-bottom:1px solid #e3e7ea;h1,h2,h3,h4,h5,h6{margin:0 !important;font-family:", " !important;font-size:11px !important;font-weight:700 !important;line-height:1.2 !important;letter-spacing:0.07em;text-transform:uppercase;color:#5a6771 !important;text-align:left !important;}"], (0, _Theme.val)("FontFamilySans"));
var HeaderCell = _styledComponents["default"].div.withConfig({
  displayName: "DeviceTableElementmodern__HeaderCell",
  componentId: "sc-16zfe3t-2"
})(["display:flex;align-items:center;justify-content:flex-start;box-sizing:border-box;padding:0 ", "px;min-width:0;overflow:hidden;"], CELL_PAD_X);
var ItemRow = _styledComponents["default"].button.withConfig({
  displayName: "DeviceTableElementmodern__ItemRow",
  componentId: "sc-16zfe3t-3"
})(["display:flex;align-items:center;box-sizing:border-box;margin:0;padding:0;border:none;border-bottom:1px solid #eff2f4;background:none;color:inherit;font:inherit;text-align:left;text-decoration:none;transition:background-color 120ms ease;&:hover{background-color:#f8fafb;color:inherit;text-decoration:none;}"]);
var ItemRowLink = ItemRow.withComponent(_reactRouterDom.Link);
var Cell = _styledComponents["default"].div.withConfig({
  displayName: "DeviceTableElementmodern__Cell",
  componentId: "sc-16zfe3t-4"
})(["color:", ";display:flex;align-items:center;justify-content:flex-start;box-sizing:border-box;min-width:0;overflow:hidden;"], (0, _Theme.val)("TextColor"));

/**
 * Displays a virtualized table of devices, repeating the supplied
 * element children for each device.
 */

var DeviceTableElement = exports.DeviceTableElement = function DeviceTableElement(props) {
  props = Object.assign({
    rowGutter: 0,
    itemHeight: 64,
    x: 0,
    y: 0,
    width: 1024,
    height: 768
  }, props);
  var _props = props,
    x = _props.x,
    y = _props.y,
    width = _props.width,
    height = _props.height,
    itemHeight = _props.itemHeight,
    rowGutter = _props.rowGutter,
    backgroundColorSource = _props.backgroundColorSource,
    children = _props.children,
    widgets = _props.widgets,
    render = _props.render,
    onClickAction = _props.onClickAction;
  var devices = _react["default"].useContext(_DeviceListContext.DeviceListContext);
  var layoutSettings = _react["default"].useContext(_ConfigurableLayout.LayoutSettingsContext);
  var _useState = (0, _react.useState)(width),
    scrollWidth = _useState[0],
    setScrollWidth = _useState[1];
  var _useState2 = (0, _react.useState)(null),
    renderedRange = _useState2[0],
    setRenderedRange = _useState2[1];
  var outerRef = /*#__PURE__*/_react["default"].createRef();

  // Metric requests are batched for the rows currently on screen.
  var itemSize = itemHeight + rowGutter;
  var listHeight = Math.max(0, height - HEADER_HEIGHT);
  var range = renderedRange || seedListRange((devices == null ? void 0 : devices.length) || 0, listHeight, itemSize);
  var visibleDevices = sliceDevices(devices, range.start, range.stop);
  var onItemsRendered = function onItemsRendered(_ref) {
    var overscanStartIndex = _ref.overscanStartIndex,
      overscanStopIndex = _ref.overscanStopIndex;
    setRenderedRange(function (prev) {
      if (prev && prev.start === overscanStartIndex && prev.stop === overscanStopIndex) {
        return prev;
      }
      return {
        start: overscanStartIndex,
        stop: overscanStopIndex
      };
    });
  };
  (0, _react.useEffect)(function () {
    if (outerRef.current) {
      setScrollWidth(outerRef.current.scrollWidth);
    }
  }, [outerRef]);
  function getColumnWidths() {
    var totalFlex = 0;
    for (var i = 0; i < children.length; i++) {
      var child = children[i];
      totalFlex += getFlexValue(child);
    }
    var availableWidth = Math.floor(scrollWidth - (children.length - 1));
    var flexWidth = availableWidth / totalFlex;
    return children.map(function (child) {
      return flexWidth * getFlexValue(child);
    });
  }
  var renderHeaders = function renderHeaders() {
    var columnWidths = getColumnWidths();
    return children.map(function (child, index) {
      var width = columnWidths[index];
      var style = {
        width: width,
        height: HEADER_HEIGHT
      };
      var widget = (0, _ConfigurableLayout.getWidget)(widgets, child.type);
      if (!widget || !widget.components.Header) {
        return /*#__PURE__*/_react["default"].createElement(HeaderCell, {
          key: String(index),
          style: style
        }, /*#__PURE__*/_react["default"].createElement(_Core.Heading, {
          level: 4,
          ellipsize: true
        }, child.type));
      }

      // Value columns get padded text headers; chart columns may draw a
      // time axis, which needs the whole cell and must not be clipped.
      var Header = widget.components.Header;
      var isChart = roleOf(child.type) == null;
      return /*#__PURE__*/_react["default"].createElement(HeaderCell, {
        key: String(index),
        style: isChart ? Object.assign({}, style, {
          padding: 0,
          overflow: "visible"
        }) : style
      }, /*#__PURE__*/_react["default"].createElement(Header, _extends({}, child.props, {
        width: isChart ? width : Math.max(0, width - 2 * CELL_PAD_X),
        height: HEADER_HEIGHT
      })));
    });
  };
  var renderItemWithColorSource = function renderItemWithColorSource(_ref2) {
    var index = _ref2.index,
      style = _ref2.style;
    return /*#__PURE__*/_react["default"].createElement(_Device.DeviceColorController, _extends({
      deviceUuid: devices[index].uuid
    }, (0, _common.getWidgetColorProps)(props)), function (_ref3) {
      var color = _ref3.color,
        backgroundColor = _ref3.backgroundColor;
      return renderItem({
        index: index,
        style: Object.assign({}, style, {
          color: color,
          backgroundColor: backgroundColor
        })
      });
    });
  };
  var renderItem = function renderItem(_ref4) {
    var index = _ref4.index,
      itemStyle = _ref4.style;
    var device = devices[index];
    var columnWidths = getColumnWidths();
    var body = [];
    for (var i = 0; i < children.length; i++) {
      var child = children[i];
      var _width = columnWidths[i];
      var role = roleOf(child.type);
      var flat = role != null;
      // The name cell paints its own state tint, so it gets the whole cell.
      var fillsCell = role === "title";
      var innerWidth = flat && !fillsCell ? Math.max(0, _width - 2 * CELL_PAD_X) : _width;
      var innerHeight = flat && !fillsCell ?
      // Most of the row: tall enough for the roomy tile (bold, large).
      Math.max(0, Math.min(itemHeight - 2 * CELL_PAD_Y, 72)) : itemHeight;
      var element = render({
        type: child.type,
        props: Object.assign({}, child.props, {
          x: 0,
          y: 0,
          width: innerWidth,
          height: innerHeight
        }),
        children: child.children
      }, i);
      body.push(/*#__PURE__*/_react["default"].createElement(Cell, {
        key: String(i),
        style: {
          width: _width,
          height: itemHeight,
          padding: flat && !fillsCell ? "0 " + CELL_PAD_X + "px" : 0
        }
      }, flat ? /*#__PURE__*/_react["default"].createElement(_TileContext.TileContext.Provider, {
        value: {
          flat: true,
          role: role,
          stateFill: fillsCell,
          cellPadding: CELL_PAD_X,
          // A table cell shows one figure: draw it large and bold, as
          // the legacy table does, whatever the row height.
          prominent: true
        }
      }, element) : element));
    }

    // A colour source on the table marks the row with a state-coloured edge
    // and a faint tint instead of a solid fill.
    var accent = itemStyle.backgroundColor,
      style = _objectWithoutPropertiesLoose(itemStyle, _excluded);
    if (accent && accent !== "transparent") {
      var edge = (0, _stateEdge.stateEdgeSize)(itemHeight, _stateEdge.STATE_EDGE_ROW_RATIO);
      style.boxShadow = "inset " + edge + "px 0 0 " + accent;
      style.backgroundColor = safeMix(0.1, accent, "#ffffff");
    }
    if (onClickAction) {
      return /*#__PURE__*/_react["default"].createElement(_DeviceContext.DeviceContext.Provider, {
        value: device
      }, /*#__PURE__*/_react["default"].createElement(_UserActions.UserAction, onClickAction, function (_ref5) {
        var getURL = _ref5.getURL,
          invoke = _ref5.invoke;
        return invoke ? /*#__PURE__*/_react["default"].createElement(ItemRow, {
          key: device.uuid,
          style: Object.assign({}, style, {
            top: style.top + (style.height - itemHeight),
            height: itemHeight
          }),
          onClick: invoke
        }, body, layoutSettings.deviceStatus.enabled && /*#__PURE__*/_react["default"].createElement(_Device.DeviceStatusOverlayController, {
          device: device
        })) : /*#__PURE__*/_react["default"].createElement(ItemRowLink, {
          key: device.uuid,
          style: Object.assign({}, style, {
            top: style.top + (style.height - itemHeight),
            height: itemHeight
          }),
          to: getURL ? getURL() : "."
        }, body, layoutSettings.deviceStatus.enabled && /*#__PURE__*/_react["default"].createElement(_Device.DeviceStatusOverlayController, {
          device: device
        }));
      }));
    }
    return /*#__PURE__*/_react["default"].createElement(ItemRow, {
      key: device.uuid,
      style: Object.assign({}, style, {
        top: style.top + (style.height - itemHeight),
        height: itemHeight
      })
    }, /*#__PURE__*/_react["default"].createElement(_DeviceContext.DeviceContext.Provider, {
      value: device
    }, body), layoutSettings.deviceStatus.enabled && /*#__PURE__*/_react["default"].createElement(_Device.DeviceStatusOverlayController, {
      device: device
    }));
  };
  return /*#__PURE__*/_react["default"].createElement(_MetricValueBatchProvider.MetricValueBatchProvider, {
    devices: devices,
    visibleDevices: visibleDevices,
    elements: children,
    backgroundColorSource: backgroundColorSource
  }, /*#__PURE__*/_react["default"].createElement(TableCard, {
    style: {
      top: y,
      left: x,
      width: width,
      height: height
    }
  }, /*#__PURE__*/_react["default"].createElement(HeaderRow, {
    style: {
      height: HEADER_HEIGHT,
      width: scrollWidth
    }
  }, renderHeaders()), /*#__PURE__*/_react["default"].createElement(_reactWindow.FixedSizeList, {
    width: width,
    height: height - HEADER_HEIGHT,
    itemCount: devices == null ? void 0 : devices.length,
    itemSize: itemHeight + rowGutter,
    outerRef: outerRef,
    onItemsRendered: onItemsRendered
  }, backgroundColorSource ? renderItemWithColorSource : renderItem)));
};
function getFlexValue(input) {
  if (typeof input.props.flex === "number") {
    return input.props.flex || 1;
  } else if (input.props.element != null && input.props.element.props != null) {
    return input.props.element.props.flex || 1;
  }
  return 1;
}
function seedListRange(itemCount, listHeight, itemSize) {
  var count = itemCount || 0;
  if (count <= 0) {
    return {
      start: 0,
      stop: -1
    };
  }
  var size = itemSize > 0 ? itemSize : 1;
  var visible = Math.ceil(Math.max(0, listHeight) / size);
  var stopIndex = Math.max(0, Math.min(count - 1, visible - 1));
  return {
    start: 0,
    stop: Math.min(count - 1, stopIndex + 2)
  };
}
function sliceDevices(devices, start, stop) {
  if (!devices || stop < start || start < 0) {
    return [];
  }
  return devices.slice(start, stop + 1);
}